import { Text } from '@mantine/core'
import React from 'react'

export function CollapsibleCardTitle({ children }: React.PropsWithChildren) {
  return (
    <Text aria-label='collapsable-card-title' fw={500}>
      {children}
    </Text>
  )
}

CollapsibleCardTitle.displayName = 'CollapsibleCard.Title'
